import * as angular from 'angular';

interface InputEnterSubmitAttributes extends angular.IAttributes {
  inputEnterSubmit: any;
}

export default angular.module('aps.directives.inputEnterSubmit', [])
  .directive('inputEnterSubmit', ($parse: angular.IParseService) => {
    return {
      restrict: 'A',
      link: (scope: angular.IScope,
             element: angular.IAugmentedJQuery,
             attributes: InputEnterSubmitAttributes) => {

             element.bind('keydown keypress', (event) => {
               switch (event.which){
                case 13:
                  let func = $parse(attributes.inputEnterSubmit);
                  func(scope);
                  event.preventDefault();
                  break;
              }
            });
      }
    };
  })
  .name;


// WEBPACK FOOTER //
// ./src/app/directives/input-enter-submit.directive.ts